import { useTranslation } from 'react-i18next';
import { Icon } from './components';

export const useWelcomeData = () => {
  const { t } = useTranslation();

  const DATA = {
    APP: [
      {
        name: `499k ${t('ratings')}`,
        value: 4.6,
        result: <Icon name="small-stars" width={69} height={12} />,
      },
      {
        name: t('age'),
        value: '4+',
        result: t('years'),
      },
      {
        name: t('chart'),
        value: (
          <>
            <span>{'No.'}</span>
            77
          </>
        ),
        result: t('navigation'),
      },
      {
        name: t('developer'),
        value: <Icon name="developer" width={28} height={28} />,
        result: 'GeoTracks labs LTD',
      },
      {
        name: t('language'),
        value: 'EN',
        result: t('plus_twelve'),
      },
      {
        name: t('size'),
        value: '69,1 ',
        result: 'MB',
      },
    ],
    INFORMATION: [
      {
        name: t('provider'),
        value: 'GEO TRACK LABS LTD',
      },
      {
        name: t('size'),
        value: '69,1 MB',
      },
      {
        name: t('category'),
        value: t('navigation'),
      },
      {
        name: t('compatibility'),
        value: t('works_on_this'),
        withIcon: true,
      },
      {
        name: t('languages'),
        value: t('english_more'),
        withIcon: true,
      },
      {
        name: t('age_rating'),
        value: '4+',
        withIcon: true,
      },
      {
        name: t('in_app_purchases'),
        value: t('yes'),
        withIcon: true,
      },
      {
        name: t('copyright'),
        value: '© 2025 Family Locator, LLC',
      },
      {
        name: t('developer_website'),
        value: <Icon name="safari" width={20} height={20} />,
        action: 'onGet',
      },
      {
        name: t('privacy_policy'),
        value: <Icon name="policy" width={20} height={20} />,
        action: 'openLink',
        href: 'https://terms.familo.net/privacy',
      },
    ],
  };

  return DATA;
};
